module.exports = __webpack_public_path__ + "img/ere.e558ca40.svg";